import { render, staticRenderFns } from "./KanTuShuoHua.vue?vue&type=template&id=f40a61d4&scoped=true"
import script from "./KanTuShuoHua.vue?vue&type=script&lang=js"
export * from "./KanTuShuoHua.vue?vue&type=script&lang=js"
import style0 from "./KanTuShuoHua.vue?vue&type=style&index=0&id=f40a61d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40a61d4",
  null
  
)

export default component.exports